import { z } from 'zod';
import { apiGet, apiPost, demoMode } from './api';
import { demoSlots, demoCreateBooking } from './demo';
import { ensureClientSession, setStoredClientPhone } from './clientIdentity';

// Слоты и создание записи. Пересечения запрещены на сервере: Pages Functions
// проверяют занятость мастера и кресла в одной транзакции D1, поэтому гонка
// двух клиентов за один слот не создаёт двойную запись.
export const SlotSchema = z.object({
  startsAt: z.string(),
  endsAt: z.string(),
  staffId: z.string(),
  staffName: z.string().optional(),
  resourceId: z.string()
});

export type Slot = z.infer<typeof SlotSchema>;

export async function fetchSlots(
  _tenantId: string,
  serviceId: string,
  staffId?: string
): Promise<Slot[]> {
  if (demoMode) {
    return z.array(SlotSchema).parse(demoSlots(serviceId, staffId));
  }

  const qs = new URLSearchParams({ serviceId });
  if (staffId) qs.set('staffId', staffId);
  const data = await apiGet<unknown>(`/slots?${qs.toString()}`);
  return z.array(SlotSchema).parse(data);
}

export type CreateBookingInput = {
  tenantId: string;
  serviceId: string;
  staffId: string;
  resourceId: string;
  startsAt: string;
  endsAt: string;
  clientName: string;
  clientPhone: string;
  // Ключ идемпотентности на попытку записи. Генерируется в BookingFlow
  // ОДИН раз и повторно используется при ретрае — иначе повторный вызов
  // после сетевого сбоя создаст вторую запись.
  idempotencyKey: string;
};

export async function createBooking(input: CreateBookingInput): Promise<string> {
  if (demoMode) {
    return demoCreateBooking(input);
  }

  // Cookie клиентской сессии выдаёт сервер; телефон запоминаем локально,
  // чтобы /api/my-bookings мог подстраховаться по номеру.
  setStoredClientPhone(input.clientPhone);
  await ensureClientSession(input.clientPhone);

  const res = await apiPost<{ id: string }>('/bookings', {
    serviceId: input.serviceId,
    staffId: input.staffId,
    resourceId: input.resourceId,
    startsAt: input.startsAt,
    endsAt: input.endsAt,
    clientName: input.clientName,
    clientPhone: input.clientPhone,
    idempotencyKey: input.idempotencyKey
  });

  return res.id;
}
